<div class="slc-data-manager-outlet">
  <ng-container cdkPortalOutlet> </ng-container>
</div>

<ng-template #content>
  @let select = selection()!;
  <div
    [slcCanTopico]="client().topicoAutorizacao"
    class="slc-data-manager-content"
    [class.slc-data-manager-content-fullscreen]="fullScreen()"
  >
    @if (!filtrando()) {
      <div class="bg-app-bar px-6 h-16 border-b left-0 flex items-center rounded-t-md">
        @if (!selection() || select.isEmpty()) {
          <h2 class="title my-0 pr-4 hidden sm:block flex-none">
            <span>{{ client().tituloCabecalho }}</span>
          </h2>
        } @else {
          @if (select.hasValue()) {
            <h2 class="subheading-2 flex-none pl-0">
              <span>{{ select.selected.length }} linha</span>
              @if (select.selected.length > 1) {
                <span>s</span>
              }
              <span> selecionada</span>
              @if (select.selected.length > 1) {
                <span>s</span>
              }
            </h2>
          }
          @if (select.hasValue()) {
            <div class="pr-4 border-r flex-none">
              <button
                (click)="select.clear()"
                class="slc-color-brand"
                mat-icon-button
                matTooltip="Limpar Seleção"
                type="button"
              >
                <mat-icon svgIcon="mat:cleaning_services"></mat-icon>
              </button>
            </div>
          }
        }

        <span class="flex-1"></span>

        <ng-container *ngTemplateOutlet="acaoToolbarTemplate()"></ng-container>

        <button
          class="flex-none ml-2"
          mat-icon-button
          matTooltip="Filtro"
          type="button"
          (click)="dmController().filtroHabilitar()"
        >
          <mat-icon svgIcon="mat:filter_alt"></mat-icon>
        </button>

        <button
          class="flex-none ml-2"
          mat-icon-button
          matTooltip="Atualizar Dados"
          type="button"
          (click)="atualizarDados()"
        >
          <mat-icon svgIcon="mat:refresh"></mat-icon>
        </button>

        <button
          class="flex-none ml-2"
          mat-icon-button
          matTooltip="Limpar Preferências"
          type="button"
          (click)="resetPreferencias()"
        >
          <mat-icon svgIcon="mat:settings_suggest"></mat-icon>
        </button>

        <button
          class="flex-none ml-2"
          mat-icon-button
          matTooltip="Colunas"
          type="button"
          [matMenuTriggerFor]="colunasConfig"
        >
          <mat-icon svgIcon="mat:filter_list"></mat-icon>
        </button>

        @if (fullScreenHabilitado) {
          <button
            (click)="alternarFullscreen()"
            class="flex-none ml-2"
            mat-icon-button
            matTooltip="Retrair"
            type="button"
          >
            <mat-icon svgIcon="mat:close_fullscreen"></mat-icon>
          </button>
        } @else {
          <button
            (click)="alternarFullscreen()"
            class="flex-none ml-2"
            mat-icon-button
            matTooltip="Expandir"
            type="button"
          >
            <mat-icon svgIcon="mat:open_in_full"></mat-icon>
          </button>
        }
      </div>
    }

    <app-data-manager-filtro [dmController]="dmController()" [info]="client().info?.filtro"></app-data-manager-filtro>

    @if (!dmController().filtros.primeiraSelecao) {
      <fieldset [disabled]="filtrando()" class="relative flex-1 flex flex-col">
        <div class="backdrop" [class.show]="filtrando()"></div>

        <app-data-manager-grupo [dmController]="dmController()"></app-data-manager-grupo>

        <div class="slc-grid-shell bg-foreground">
          <div class="slc-grid-header-scroll" #headerScrollEl (scroll)="onHeaderScroll($event)">
            <div
              class="slc-grid-header"
              [style.grid-template-columns]="gridTemplateDados()"
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="colunas()"
              [cdkDropListSortPredicate]="dropColunaSortPredicate"
              (cdkDropListDropped)="dropColuna($event)"
            >
              @if (selConfig) {
                <div class="slc-grid-header-cell slc-grid-header-cell-selecao">
                  @if (linhasVisiveis().length > 0) {
                    <mat-checkbox
                      class="slc-checkbox-brand"
                      (change)="onSelecionarTodos()"
                      [checked]="selecaoTodosSelecionados()"
                      (click)="$event.stopPropagation()"
                      [indeterminate]="selecaoIndeterminada()"
                    ></mat-checkbox>
                  }
                </div>
              }

              <div
                class="slc-grid-header-cell slc-grid-header-cell-filler"
                [style.width.rem]="dmController().niveisGrupo"
              ></div>

              @for (coluna of colunas(); track coluna.id) {
                <div
                  class="slc-grid-header-cell slc-data-manager-table-header"
                  cdkDrag
                  [cdkDragData]="coluna"
                  [cdkDragDisabled]="dragDesabilitado(coluna)"
                >
                  <div class="slc-grid-header-content">
                    <span
                      class="slc-grid-header-title"
                      [class.text-center]="coluna.tipoDado === 'valor'"
                      [matTooltip]="coluna.tooltip"
                      >{{ coluna.descricao }}</span
                    >
                    <div class="slc-grid-header-meta">
                      <div class="slc-grid-header-status">
                        <ng-container *ngTemplateOutlet="statusColuna; context: { $implicit: coluna }"></ng-container>
                      </div>
                      <button
                        mat-icon-button
                        type="button"
                        class="slc-data-manager-action"
                        [cdkMenuTriggerFor]="menu.colunasMenu()"
                        [cdkMenuTriggerData]="{ $implicit: coluna }"
                      >
                        <mat-icon svgIcon="mat:more_vert"></mat-icon>
                      </button>
                    </div>
                  </div>
                  <div
                    class="slc-grid-resize-handle"
                    (mousedown)="onResizeStart($event, coluna)"
                    (dblclick)="onResizeDoubleClick($event, coluna)"
                  ></div>
                </div>
              }

              @if (acaoTabelaTemplate()) {
                <div class="slc-grid-header-cell slc-grid-header-cell-acao text-center">Ação</div>
              }
            </div>
          </div>

          <div
            class="slc-grid-overlay-anchor"
            #overlayScrollEl
            aria-hidden="true"
            [class.slc-grid-overlay-pronto]="overlayPronto()"
          >
            <div class="slc-grid-overlay" [style.--slc-height-offset.px]="gruposOverlayAtivos().offset">
              @for (row of gruposOverlayAtivos().gruposAtivos; track $index) {
                <div
                  class="slc-grid-row slc-grid-row-grupo slc-grid-row-overlay"
                  [style.grid-template-columns]="gridTemplateGrupo()"
                  [style.zIndex]="50 - $index"
                  (click)="onLinhaClick(row)"
                >
                  @if (selConfig) {
                    <div class="slc-grid-cell slc-grid-cell-selecao">
                      @if (selecaoHabilitada(row)) {
                        <mat-checkbox
                          class="slc-checkbox-brand"
                          (change)="onSelecionarTodosGrupo(row)"
                          [checked]="selecaoTodosSelecionadosGrupo(row)"
                          (click)="$event.stopPropagation()"
                          [indeterminate]="selecaoIndeterminadaGrupo(row)"
                        ></mat-checkbox>
                      }
                    </div>
                  }

                  <div class="slc-grid-cell slc-grid-cell-filler" [style.width.rem]="dmController().niveisGrupo"></div>

                  <div
                    class="slc-grid-cell slc-grid-cell-grupo"
                    [cdkContextMenuTriggerFor]="menu.gruposMenu()"
                    [cdkContextMenuTriggerData]="{ $implicit: row }"
                  >
                    @if (row) {
                      <div
                        [style]="'padding-left: ' + (grupoNivel(row) - 1) + 'rem;'"
                        class="flex flex-row items-center font-bold"
                      >
                        @if (grupoExpandido(row)) {
                          <mat-icon svgIcon="mat:arrow_drop_up"></mat-icon>
                        } @else {
                          <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
                        }

                        @if (grupoColuna(row)?.templateGrupo) {
                          <ng-container
                            *ngTemplateOutlet="
                              grupoColuna(row)?.templateGrupo;
                              context: { linha: row, coluna: grupoColuna(row) }
                            "
                          ></ng-container>
                        } @else {
                          {{ grupoDescricao(row) }}
                        }
                        ({{ grupoTotalItens(row) }})
                      </div>
                    }
                  </div>

                  @for (colunaGrupo of colunasTotais(); track colunaGrupo.id) {
                    <div
                      class="slc-grid-cell"
                      [class.slc-grid-cell-valor]="
                        colunaGrupo.tipoDado === 'valor' || colunaGrupo.tipoDado === 'percentual'
                      "
                      [cdkContextMenuTriggerFor]="menu.gruposMenu()"
                      [cdkContextMenuTriggerData]="{ $implicit: row }"
                    >
                      @if (row && colunaGrupo.config.total) {
                        {{ grupoTotalColuna(row, colunaGrupo) | number: '0.2-2' }}
                      }
                    </div>
                  }

                  @if (acaoTabelaTemplate()) {
                    <div class="slc-grid-cell slc-grid-cell-acao">
                      <ng-container *ngTemplateOutlet="acaoTabelaTemplate(); context: { linha: row }"></ng-container>
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          <cdk-virtual-scroll-viewport
            [itemSize]="itemSizePx()"
            minBufferPx="900"
            maxBufferPx="900"
            class="slc-grid-viewport"
            (scroll)="onViewportScroll($event)"
          >
            <div
              *cdkVirtualFor="let row of linhasVisiveis(); trackBy: trackByLinha"
              class="slc-grid-row hover:bg-hover"
              [style.grid-template-columns]="gridTemplateLinha(row)"
              [class.slc-grid-row-grupo]="isGrupo(row)"
              (click)="onLinhaClick(row)"
            >
              @if (selConfig) {
                <div class="slc-grid-cell slc-grid-cell-selecao">
                  @if (selecaoHabilitada(row)) {
                    @if (row.isGrupo) {
                      <mat-checkbox
                        class="slc-checkbox-brand"
                        (change)="onSelecionarTodosGrupo(row)"
                        [checked]="selecaoTodosSelecionadosGrupo(row)"
                        (click)="$event.stopPropagation()"
                        [indeterminate]="selecaoIndeterminadaGrupo(row)"
                      ></mat-checkbox>
                    } @else {
                      <mat-checkbox
                        class="slc-checkbox-brand"
                        (click)="$event.stopPropagation()"
                        (change)="$event ? selection()?.toggle(row) : null"
                        [checked]="selection()?.isSelected(row)"
                      ></mat-checkbox>
                    }
                  }
                </div>
              }

              <div class="slc-grid-cell slc-grid-cell-filler" [style.width.rem]="dmController().niveisGrupo"></div>

              @if (row.isGrupo) {
                <div
                  class="slc-grid-cell slc-grid-cell-grupo"
                  [style.grid-column]="'span ' + grupoColunasSpan()"
                  [cdkContextMenuTriggerFor]="menu.gruposMenu()"
                  [cdkContextMenuTriggerData]="{ $implicit: row }"
                >
                  <div
                    [style]="'padding-left: ' + (grupoNivel(row) - 1) + 'rem;'"
                    class="flex flex-row items-center font-bold"
                  >
                    @if (grupoExpandido(row)) {
                      <mat-icon svgIcon="mat:arrow_drop_up"></mat-icon>
                    } @else {
                      <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
                    }

                    @if (grupoColuna(row)?.templateGrupo) {
                      <ng-container
                        *ngTemplateOutlet="
                          grupoColuna(row)?.templateGrupo;
                          context: { linha: row, coluna: grupoColuna(row) }
                        "
                      ></ng-container>
                    } @else {
                      {{ grupoDescricao(row) }}
                    }
                    ({{ grupoTotalItens(row) }})
                  </div>
                </div>

                @for (colunaGrupo of colunasTotais(); track colunaGrupo.id) {
                  <div
                    class="slc-grid-cell"
                    [class.slc-grid-cell-valor]="
                      colunaGrupo.tipoDado === 'valor' || colunaGrupo.tipoDado === 'percentual'
                    "
                    [cdkContextMenuTriggerFor]="menu.gruposMenu()"
                    [cdkContextMenuTriggerData]="{ $implicit: row }"
                  >
                    @if (colunaGrupo.config.total) {
                      {{ grupoTotalColuna(row, colunaGrupo) | number: '0.2-2' }}
                    }
                  </div>
                }
              } @else {
                @for (coluna of colunas(); track coluna.id) {
                  <div
                    class="slc-grid-cell"
                    [class.slc-grid-cell-valor]="coluna.tipoDado === 'valor' || coluna.tipoDado === 'percentual'"
                    [cdkContextMenuTriggerFor]="menu.colunasMenu()"
                    [cdkContextMenuTriggerData]="{ $implicit: coluna }"
                  >
                    @if (coluna.templateDados) {
                      <div class="flex flex-1 items-center pr-9">
                        <ng-container
                          *ngTemplateOutlet="coluna.templateDados; context: { linha: row, coluna }"
                        ></ng-container>
                      </div>
                    } @else if (coluna.tipoDado === 'valor') {
                      <div class="text-right">
                        {{ getValorLinha(row, coluna) | number: '0.2-2' }}
                      </div>
                    } @else if (coluna.tipoDado === 'data') {
                      {{ getValorLinha(row, coluna) | date }}
                    } @else {
                      <div>{{ getValorLinha(row, coluna) }}</div>
                    }
                  </div>
                }
              }

              @if (acaoTabelaTemplate()) {
                <div class="slc-grid-cell slc-grid-cell-acao">
                  <ng-container *ngTemplateOutlet="acaoTabelaTemplate(); context: { linha: row }"></ng-container>
                </div>
              }
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </fieldset>
    }
  </div>
</ng-template>

<app-data-manager-menu #menu [dmController]="dmController()"></app-data-manager-menu>

<mat-menu #maisOpcoes="matMenu">
  <button mat-menu-item (click)="atualizarDados()">
    <mat-icon svgIcon="mat:refresh"></mat-icon>
    <span>Atualizar Dados</span>
  </button>
  <button mat-menu-item (click)="resetPreferencias()">
    <mat-icon svgIcon="mat:settings_suggest"></mat-icon>
    <span>Limpar Preferências</span>
  </button>
</mat-menu>

<ng-template #statusColuna let-coluna>
  <div class="opacity-50 flex flex-col items-center slc-data-manager-status-coluna">
    <mat-icon svgIcon="mat:arrow_upward" [class.hidden]="coluna.config.ordenacao !== 'asc'" class="icon-xs"></mat-icon>
    <mat-icon
      svgIcon="mat:arrow_downward"
      [class.hidden]="coluna.config.ordenacao !== 'desc'"
      class="icon-xs"
    ></mat-icon>
    @if (coluna.tipoColuna !== 'dadoAdicional') {
      <mat-icon svgIcon="mat:functions" [class.hidden]="!coluna.config.total" class="icon-xs"></mat-icon>
    }
  </div>
</ng-template>

<mat-menu #colunasConfig="matMenu">
  @for (coluna of colunasSemDadoAdicional(); track coluna.id) {
    <div mat-menu-item role="menuitemcheckbox" (click)="$event.stopPropagation()">
      <mat-checkbox [checked]="!coluna.config.ocultarColuna" (change)="onToggleOcultarColuna(coluna)">{{
        coluna.descricao
      }}</mat-checkbox>
    </div>
  }
</mat-menu>
